module.exports = __webpack_public_path__ + "../resources/img/ic_snow_heavy_weather.4a4df89f.svg";